export const GET_PROFILE = 'GET_PROFILE'
export const GET_PROFILE_SUCCESS = 'GET_PROFILE_SUCCESS'

export const UPDATE_PROFILE = 'UPDATE_PROFILE'

export const UPDATE_KYC = 'UPDATE_KYC'
